'use strict';

angular.module('shiftTraderApp')
  .controller('QuickAddShiftsModalCtrl', function($scope, params, $uibModalInstance, TimeService, WorkPeriods,
                                                  WorkPeriodStore, $timeout, toastr, ShepherdTourService, $controller) {

    var baseCtrl = $controller('BaseQuickAddRowCtrl', {$scope: $scope, params: params, $uibModalInstance: $uibModalInstance});


    $scope.currentDate = params.currentDate;

    var openTime = TimeService.getNowInStoreTime();
    if ($scope.currentDate.isBefore(openTime) || $scope.currentDate.isSame(openTime)) {
      toastr.warning('You are adding shifts to today. Please note that new shifts can only be added in the future.', 'Warning');
    }

    $scope.addAnotherRow();

    $scope.createShifts = function() {
      var nowTime = TimeService.getNowInStoreTime();
      var bailout = false;
      _.each($scope.positionRows, function(row) {
        _.each(row.objects, function(obj) {
          if (!obj.d.parsed) {
            toastr.error('Please fix invalid shift time for the ' + _.find($scope.allPositions, {id: row.positionId}).name + ' position.', 'Error');
            bailout = true;
            return false;
          }

          if (obj.d.start.dt.isBefore(nowTime) || obj.d.start.dt.isSame(nowTime)) {
            toastr.error('At least 1 shift that starts before the current in store time. Please remove them.', 'Error');
            bailout = true;
            obj.d._beforeNow = true;
          }

        });
      });

      if (bailout) {
        return false;
      }

      var workPeriodsCreated = [];
      $scope.state = {
        totalShifts: 0,
        numShiftsCreated: 0,
        currentlyCreating: true
      };

      _.each($scope.positionRows, function(positionRow) {
        var parsedObjects = _.where(positionRow.objects, function(obj) {
          return obj.d.parsed;
        });
        $scope.state.totalShifts += parsedObjects.length;

        _.each(parsedObjects, function(obj, i) {
          var data = {
            position_id: positionRow.positionId,
            start_time: obj.d.start.dt.utc().format(),
            end_time: obj.d.end.dt.utc().format(),
            organization_id: $scope.org.id
          };
          WorkPeriods.create(data)
              .then(function(wp) {
                workPeriodsCreated.push(wp);
                WorkPeriodStore.addWorkPeriod(wp)
                    .then(function() {
                      //must use the promise here so that the addition occurs BEFORE the refresh on manageWorkPeriods
                      $scope.state.numShiftsCreated += 1;
                    });
              });
        });
      });

      $scope.$watch('state.numShiftsCreated', function(newVal) {
        console.log('WATCH FIRED: state.numShiftsCreated', newVal, $scope.state.totalShifts);
        if (newVal === $scope.state.totalShifts && $scope.state.totalShifts > 0) {
          ShepherdTourService.triggerEvent('quickAddClosed', 1000);
         $uibModalInstance.close(workPeriodsCreated);
        }
      });

    };

    ShepherdTourService.triggerEvent('quickAddOpened', 500);
  });
